export const stateAbbreviations = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  DC: 'Washington D.C.',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const hasPsychiatry = [
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Illinois',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'New Hampshire',
  'New Jersey',
  'North Carolina',
  'Ohio',
  'Pennsylvania',
  'South Carolina',
  'Texas',
  'Virginia',
  'Washington D.C.',
]

export const hasLocations = {
  Alaska: [
    {
      link: 'anchorage-counseling',
      addressLine1: '670 West Fireweed Ln Suite 100',
      addressLine2: 'Anchorage, AK 99503',
    },
  ],
  Alabama: [
    {
      link: 'huntsville-counseling',
      addressLine1: '1101 McMurtrie Drive Northwest Suite C3',
      addressLine2: 'Huntsville, AL 35806',
    },
    {
      link: 'birmingham-therapy',
      addressLine1: '400 Office Park Drive Suite 308',
      addressLine2: 'Birmingham, AL 35223',
    },
    {
      link: 'tuscaloosa-counseling',
      addressLine1: '2315 9th St Suite 4B',
      addressLine2: 'Tuscaloosa, AL 35401',
    },
    {
      link: 'montgomery-counseling',
      addressLine1: '1736 Taliaferro Trail',
      addressLine2: 'Montgomery, AL 36117',
    },
  ],
  Arkansas: [
    {
      link: 'bentonville-counseling',
      addressLine1: '809 SW I St Suite 23',
      addressLine2: 'Bentonville, AR 72712',
    },
    {
      link: 'maumelle-counseling',
      addressLine1: '102 Country Club Pkwy Suite A',
      addressLine2: 'Maumelle, AR 72113',
    },
    {
      link: 'north-little-rock-counseling',
      addressLine1: '4704 W Commercial Dr Suite A',
      addressLine2: 'North Little Rock, AR 72116',
    },
    {
      link: 'conway-counseling',
      addressLine1: '685 Shelby Trail Suite 105',
      addressLine2: 'Conway, AR 72034',
    },
    {
      link: 'jonesboro-counseling',
      addressLine1: '1814 Executive Square',
      addressLine2: 'Jonesboro, AR 72401',
    },
  ],
  Arizona: [
    {
      link: 'phoenix-counseling',
      addressLine1: '1110 E Missouri Ave Suite 340',
      addressLine2: 'Phoenix, AZ 85014',
    },
    {
      link: 'flagstaff-counseling',
      addressLine1: '809 W Riordan Rd Suite 202',
      addressLine2: 'Flagstaff, AZ 86001',
    },
    {
      link: 'peoria-counseling',
      addressLine1: '9401 West Thunderbird Rd Suite 188',
      addressLine2: 'Peoria, AZ 85381',
    },
    {
      link: 'tempe-counseling',
      addressLine1: '4801 South Lakeshore Dr Suite 207',
      addressLine2: 'Tempe, AZ 85282',
    },
    {
      link: 'gilbert-counseling',
      addressLine1: '1760 E Pecos Rd Suite 344',
      addressLine2: 'Gilbert, AZ 85295',
    },
    {
      link: 'phoenix-counseling-therapy',
      addressLine1: '4530 E Ray Rd Suite 120',
      addressLine2: 'Phoenix, AZ 85044',
    },
    {
      link: 'tucson-counseling',
      addressLine1: '333 E Wetmore Rd Suite 137',
      addressLine2: 'Tucson, AZ 85705',
    },
  ],
  California: [
    {
      link: 'long-beach-counseling',
      addressLine1: '2760 E Spring St Suite 202',
      addressLine2: 'Long Beach, CA 90806',
    },
    {
      link: 'san-bernardino-counseling',
      addressLine1: '1585 South D St Suite 213',
      addressLine2: 'San Bernardino, CA 92408',
    },
    {
      link: 'vallejo-counseling',
      addressLine1: '631 Tennessee St Suite 101',
      addressLine2: 'Vallejo, CA 94590',
    },
    {
      link: 'irvine-counseling',
      addressLine1: '4902 Irvine Center Dr Suite 203',
      addressLine2: 'Irvine, CA 92604',
    },
    {
      link: 'san-diego-counseling',
      addressLine1: '2525 Camino del Rio S Suite 301',
      addressLine2: 'San Diego, CA 92108',
    },
    {
      link: 'thousand-oaks-counseling',
      addressLine1: '2804 Camino Dos Rios Suite 206',
      addressLine2: 'Thousand Oaks, CA 91360',
    },
    {
      link: 'roseville-counseling',
      addressLine1: '420 Folsom Rd Suite A-12',
      addressLine2: 'Roseville, CA 95678',
    },
    {
      link: 'fairfield-ca-counseling',
      addressLine1: '2480 Hilborn Rd Suite 101',
      addressLine2: 'Fairfield, CA 94534',
    },
    {
      link: 'san-jose-counseling',
      addressLine1: '2025 Forest Ave Suite 5',
      addressLine2: 'San Jose, CA 95128',
    },
    {
      link: 'fremont-counseling',
      addressLine1: '39420 Liberty St Suite 265',
      addressLine2: 'Fremont, CA 94538',
    },
    {
      link: 'modesto-counseling',
      addressLine1: '3600 Sisk Rd Building 4A Office 4',
      addressLine2: 'Modesto, CA 95356',
    },
    {
      link: 'stockton-counseling',
      addressLine1: '120 N Hunter St Suite 306',
      addressLine2: 'Stockton, CA 95202',
    },
    {
      link: 'riverside-counseling',
      addressLine1: '6391 Magnolia Ave Suite 4',
      addressLine2: 'Riverside, CA 92506',
    },
    {
      link: 'palo-alto-counseling',
      addressLine1: '480 S California Ave Suite 104',
      addressLine2: 'Palo Alto, CA 94306',
    },
    {
      link: 'san-francisco-therapy',
      addressLine1: '815 Hyde St Suite 301',
      addressLine2: 'San Francisco, CA 94109',
    },
    {
      link: 'berkeley-counseling',
      addressLine1: '2020 Milvia St Suite 200',
      addressLine2: 'Berkeley, CA 94704',
    },
    {
      link: 'la-habra-counseling',
      addressLine1: '731 North Beach Boulevard Suite 140',
      addressLine2: 'La Habra, CA 90631',
    },
    {
      link: 'huntington-beach-counseling',
      addressLine1: '18652 Florida St Suite 245',
      addressLine2: 'Huntington Beach, CA 92648',
    },
  ],
  Colorado: [
    {
      link: 'loveland-counseling',
      addressLine1: '118 E 29th St Suite B',
      addressLine2: 'Loveland, CO 80538',
    },
    {
      link: 'greeley-counseling',
      addressLine1: '4239 Centerplace Dr Suite 2F',
      addressLine2: 'Greeley, CO 80634',
    },
    {
      link: 'longmont-counseling',
      addressLine1: '525 3rd Ave Suite 108',
      addressLine2: 'Longmont, CO 80501',
    },
    {
      link: 'colorado-springs-counseling',
      addressLine1: '5410 Powers Center Point Suite 210',
      addressLine2: 'Colorado Springs, CO 80920',
    },
    {
      link: 'colorado-springs-therapy',
      addressLine1: '1230 Tenderfoot Hill Rd Suite 305',
      addressLine2: 'Colorado Springs, CO 80906',
    },
    {
      link: 'colorado-springs-counseling-therapy',
      addressLine1: '5475 Mark Dabling Blvd Suite 100',
      addressLine2: 'Colorado Springs, CO 80918',
    },
    {
      link: 'pueblo-counseling',
      addressLine1: '200 West City Center Dr Suite 302',
      addressLine2: 'Pueblo, CO 81003',
    },
    {
      link: 'boulder-counseling',
      addressLine1: '4155 Darley Avenue Suite F-3',
      addressLine2: 'Boulder, CO 80305',
    },
    {
      link: 'centennial-counseling',
      addressLine1: '7853 E Arapahoe Ct Suite 2700',
      addressLine2: 'Centennial, CO 80112',
    },
    {
      link: 'aurora-counseling',
      addressLine1: '14707 E 2nd Ave Suite 230',
      addressLine2: 'Aurora, CO 80011',
    },
    {
      link: 'westminster-counseling',
      addressLine1: '8510 Bryant St Suite 340',
      addressLine2: 'Westminster, CO 80031',
    },
    {
      link: 'littleton-counseling',
      addressLine1: '9200 West Cross Drive Suite 514',
      addressLine2: 'Littleton, CO 80123',
    },
  ],
  Connecticut: [
    {
      link: 'stamford-counseling',
      addressLine1: '80 Mill River St Suite 2200',
      addressLine2: 'Stamford, CT 06902',
    },
    {
      link: 'milford-counseling',
      addressLine1: '70 Cherry St',
      addressLine2: 'Milford, CT 06460',
    },
    {
      link: 'west-hartford-counseling',
      addressLine1: '846 Farmington Ave Suite 4',
      addressLine2: 'West Hartford, CT 06119',
    },
    {
      link: 'fairfield-counseling',
      addressLine1: '2452 Black Rock Turnpike Suite O5',
      addressLine2: 'Fairfield, CT 06825',
    },
    {
      link: 'norwalk-counseling',
      addressLine1: '64 Wall Street Suite 200',
      addressLine2: 'Norwalk, CT 06850',
    },
    {
      link: 'new-haven-counseling',
      addressLine1: '136 Sherman Ave Suite 402',
      addressLine2: 'New Haven, CT 06511',
    },
    {
      link: 'manchester-therapy',
      addressLine1: '360 Tolland Turnpike Suite 2F',
      addressLine2: 'Manchester, CT 06042',
    },
    {
      link: 'cheshire-counseling',
      addressLine1: '609 West Johnson Ave Suite 400',
      addressLine2: 'Cheshire, CT 06410',
    },
  ],
  'Washington D.C.': [
    {
      link: 'washington-dc-counseling',
      addressLine1: '529 14th St NW Suite 1170',
      addressLine2: 'Washington, DC 20045',
    },
    {
      link: 'washington-dc-therapy',
      addressLine1: '1010 Wisconsin Ave NW Suite 340',
      addressLine2: 'Washington, DC 20007',
    },
    {
      link: 'washington-dc-union-station-counseling',
      addressLine1: '505 Capitol Ct NE Suite 300',
      addressLine2: 'Washington, DC 20002',
    },
  ],
  Delaware: [
    {
      link: 'wilmington-counseling',
      addressLine1: '300 Delaware Ave Suite 1205',
      addressLine2: 'Wilmington, DE 19801',
    },
    {
      link: 'dover-counseling',
      addressLine1: '1326 S Governors Ave Suite A',
      addressLine2: 'Dover, DE 19904',
    },
  ],
  Florida: [
    {
      link: 'jacksonville-counseling',
      addressLine1: '4243 Sunbeam Road Suite 6',
      addressLine2: 'Jacksonville, FL 32257',
    },
    {
      link: 'fort-lauderdale-counseling',
      addressLine1: '2425 E Commercial Blvd Suite 405',
      addressLine2: 'Fort Lauderdale, FL 33308',
    },
    {
      link: 'jacksonville-therapy',
      addressLine1: '4070 Herschel St Suite 1',
      addressLine2: 'Jacksonville, FL 32210',
    },
    {
      link: 'boca-raton-counseling',
      addressLine1: '7999 N Federal Hwy Suite 200',
      addressLine2: 'Boca Raton, FL 33487',
    },
    {
      link: 'west-palm-beach-counseling',
      addressLine1: '1601 Belvedere Rd Suite S-204',
      addressLine2: 'West Palm Beach, FL 33406',
    },
    {
      link: 'tampa-counseling',
      addressLine1: '4115 W Spruce St Suite 205',
      addressLine2: 'Tampa, FL 33607',
    },
    {
      link: 'orlando-therapy',
      addressLine1: '6150 Metrowest Blvd Suite 305',
      addressLine2: 'Orlando, FL 32835',
    },
    {
      link: 'maitland-counseling',
      addressLine1: '2700 Westhall Ln Suite 118',
      addressLine2: 'Maitland, FL 32751',
    },
    {
      link: 'boynton-beach-counseling',
      addressLine1: '7593 Boynton Beach Blvd Suite 120',
      addressLine2: 'Boynton Beach, FL 33437',
    },
    {
      link: 'gainesville-counseling',
      addressLine1: '4210 NW 37th Pl Suite 700',
      addressLine2: 'Gainesville, FL 32606',
    },
    {
      link: 'tallahassee-counseling',
      addressLine1: '2852 Remington Green Cir #203',
      addressLine2: 'Tallahassee, FL 32308',
    },
    {
      link: 'coral-springs-counseling',
      addressLine1: '10100 W Sample Rd Suite 205',
      addressLine2: 'Coral Springs, FL 33065',
    },
    {
      link: 'clearwater-counseling',
      addressLine1: '501 S Lincoln Ave Suite 24',
      addressLine2: 'Clearwater, FL 33756',
    },
    {
      link: 'davie-counseling',
      addressLine1: '2924 Davie Rd #103',
      addressLine2: 'Davie, FL 33314',
    },
  ],
  Georgia: [
    {
      link: 'atlanta-counseling',
      addressLine1: '8800 Roswell Road Suite A-135, Suite A-245',
      addressLine2: 'Atlanta, GA 30350',
    },
    {
      link: 'marietta-counseling',
      addressLine1: '25 Whitlock Pl SW Suite 101',
      addressLine2: 'Marietta, GA 30064',
    },
    {
      link: 'peachtree-city-counseling',
      addressLine1: '200 Westpark Drive Suite 120',
      addressLine2: 'Peachtree City, GA 30269',
    },
    {
      link: 'kennesaw-counseling',
      addressLine1: '3745 Cherokee St NW Suite 903',
      addressLine2: 'Kennesaw, GA 30144',
    },
    {
      link: 'cumming-counseling',
      addressLine1: '6010 Southard Trace',
      addressLine2: 'Cumming, GA 30040',
    },
    {
      link: 'alpharetta-counseling',
      addressLine1: '1025 Powers Pl',
      addressLine2: 'Alpharetta, GA 30009',
    },
    {
      link: 'atlanta-therapy',
      addressLine1: '2999 Piedmont Rd NE Suite 100',
      addressLine2: 'Atlanta, GA 30305',
    },
    {
      link: 'atlanta-duluth-counseling',
      addressLine1: '6290 Abbotts Bridge Rd Suite 304',
      addressLine2: 'Duluth, GA 30097',
    },
    {
      link: 'atlanta-smyrna-counseling',
      addressLine1: '1850 Lake Park Dr SE Suite 216',
      addressLine2: 'Smyrna, GA 30080',
    },
    {
      link: 'lawrenceville-counseling',
      addressLine1: '884 Legacy Park Dr Suite 302',
      addressLine2: 'Lawrenceville, GA 30043',
    },
    {
      link: 'dallas-therapy',
      addressLine1: '2713 Charles Hardy Pkwy Suite 223',
      addressLine2: 'Dallas, GA 30157',
    },
    {
      link: 'athens-counseling',
      addressLine1: '644 N Chase St Suite 104',
      addressLine2: 'Athens, GA 30606',
    },
    {
      link: 'dacula-counseling',
      addressLine1: '2089 Teron Trace Suite 220',
      addressLine2: 'Dacula, GA 30019',
    },
    {
      link: 'savannah-counseling-therapy',
      addressLine1: '125 E Broad Street Suite 1C',
      addressLine2: 'Savannah, GA 31401',
    },
    {
      link: 'woodstock-counseling',
      addressLine1: '3221 S Cherokee Ln Suite 1810',
      addressLine2: 'Woodstock, GA 30188',
    },
    {
      link: 'mcdonough-counseling',
      addressLine1: '1725 Pennsylvania Avenue',
      addressLine2: 'McDonough, GA 30253',
    },
  ],
  Hawaii: [
    {
      link: 'kailua-counseling',
      addressLine1: '93 N Kainalu Dr Suite B',
      addressLine2: 'Kailua, HI 96734',
    },
  ],
  Iowa: [
    {
      link: 'cedar-rapids-counseling',
      addressLine1: '725 Boyson Road Northeast Suite 100',
      addressLine2: 'Cedar Rapids, IA 52402',
    },
    {
      link: 'west-des-moines-counseling',
      addressLine1: '7205 Vista Dr Suite 100',
      addressLine2: 'West Des Moines, IA 50266',
    },
    {
      link: 'iowa-city-counseling',
      addressLine1: '1275 Highway 1-W Suite 1',
      addressLine2: 'Iowa City, IA 52246',
    },
    {
      link: 'davenport-counseling',
      addressLine1: '736 Federal St Unit 1-106',
      addressLine2: 'Davenport, IA 52803',
    },
  ],
  Idaho: [
    {
      link: 'boise-counseling',
      addressLine1: '405 S 8th St Suite 290',
      addressLine2: 'Boise, ID 83702',
    },
    {
      link: 'meridian-counseling',
      addressLine1: '26 N Baltic Place Suite 150',
      addressLine2: 'Meridian, ID 83642',
    },
    {
      link: 'nampa-counseling',
      addressLine1: '136 N Broadmore Way #103',
      addressLine2: 'Nampa, ID 83687',
    },
  ],
  Illinois: [
    {
      link: 'chicago-counseling',
      addressLine1: '6645 N Oliphant Ave Suite B',
      addressLine2: 'Chicago, IL 60631',
    },
    {
      link: 'aurora-therapy',
      addressLine1: '75 Executive Dr Suite 315D',
      addressLine2: 'Aurora, IL 60504',
    },
    {
      link: 'chicago-therapy',
      addressLine1: '333 N Michigan Ave Suite 1810',
      addressLine2: 'Chicago, IL 60601',
    },
    {
      link: 'normal-counseling',
      addressLine1: '314 Susan Dr Suite B',
      addressLine2: 'Normal, IL 61761',
    },
    {
      link: 'champaign-counseling',
      addressLine1: '205 West Park Ave Suite 103',
      addressLine2: 'Champaign, IL 61820',
    },
    {
      link: 'chicago-river-west-counseling',
      addressLine1: '770 N Halsted St Suite 201',
      addressLine2: 'Chicago, IL 60642',
    },
    {
      link: 'evanston-counseling',
      addressLine1: '1724 Sherman Ave Suite 202',
      addressLine2: 'Evanston, IL 60201',
    },
    {
      link: 'woodridge-counseling',
      addressLine1: '7425 Janes Ave #205',
      addressLine2: 'Woodridge, IL 60517',
    },
    {
      link: 'evergreen-park-counseling',
      addressLine1: '9730 S Western Ave #350',
      addressLine2: 'Evergreen Park, IL 60805',
    },
    {
      link: 'hoffman-estates-counseling',
      addressLine1: '2500 W Higgins Rd #935',
      addressLine2: 'Hoffman Estates, IL 60169',
    },
    {
      link: 'joliet-counseling',
      addressLine1: '1051 Essington Road Suite 280',
      addressLine2: 'Joliet, IL 60435',
    },
  ],
  Indiana: [
    {
      link: 'lafayette-counseling',
      addressLine1: '250 Main St Suite 420',
      addressLine2: 'Lafayette, IN 47901',
    },
    {
      link: 'munster-counseling',
      addressLine1: '9245 Calumet Ave Suite 100-I',
      addressLine2: 'Munster, IN 46321',
    },
    {
      link: 'indianapolis-therapy',
      addressLine1: '429 N Pennsylvania St Suite 111',
      addressLine2: 'Indianapolis, IN 46204',
    },
    {
      link: 'noblesville-counseling',
      addressLine1: '14540 Prairie Lakes Blvd Suite 100',
      addressLine2: 'Noblesville, IN 46060',
    },
    {
      link: 'carmel-counseling',
      addressLine1: '755 W Carmel Dr Suite 209',
      addressLine2: 'Carmel, IN 46032',
    },
  ],
  Kansas: [
    {
      link: 'lawrence-counseling',
      addressLine1: '1505 Kasold Dr Suite 7',
      addressLine2: 'Lawrence, KS 66047',
    },
    {
      link: 'topeka-counseling',
      addressLine1: '120 Southeast 6th Street Suite 4-116',
      addressLine2: 'Topeka, KS 66603',
    },
  ],
  Kentucky: [
    {
      link: 'bowling-green-counseling',
      addressLine1: '310 E Main Ave Suite 202',
      addressLine2: 'Bowling Green, KY 42101',
    },
    {
      link: 'lexington-therapy',
      addressLine1: '120 Prosperous Pl Suite 207',
      addressLine2: 'Lexington, KY 40509',
    },
    {
      link: 'louisville-counseling',
      addressLine1: '4122 Shelbyville Rd Suite 120',
      addressLine2: 'Louisville, KY 40207',
    },
  ],
  Louisiana: [
    {
      link: 'baton-rouge-counseling',
      addressLine1: '8888 Jefferson Hwy Suite B',
      addressLine2: 'Baton Rouge, LA 70809',
    },
    {
      link: 'new-orleans-counseling',
      addressLine1: '334 N Norman C Francis Pkwy',
      addressLine2: 'New Orleans, LA 70119',
    },
    {
      link: 'lafayette-therapy',
      addressLine1: '1602 West Pinhook Road Suite 102',
      addressLine2: 'Lafayette, LA 70508',
    },
    {
      link: 'shreveport-counseling',
      addressLine1: '6560 Youree Dr Suite 1003',
      addressLine2: 'Shreveport, LA 71105',
    },
  ],
  Massachusetts: [
    {
      link: 'westborough-counseling',
      addressLine1: '5 E Main St Suite 3',
      addressLine2: 'Westborough, MA 01581',
    },
    {
      link: 'framingham-counseling',
      addressLine1: '463 Worcester Rd Suite 406',
      addressLine2: 'Framingham, MA 01701',
    },
    {
      link: 'boston-counseling',
      addressLine1: '1 Emerson Pl Suite 3H',
      addressLine2: 'Boston, MA 02114',
    },
    {
      link: 'leominster-counseling',
      addressLine1: '114 Merriam Ave Suite 203',
      addressLine2: 'Leominster, MA 01453',
    },
    {
      link: 'quincy-counseling',
      addressLine1: '101 Adams St Suite 26',
      addressLine2: 'Quincy, MA 02169',
    },
    {
      link: 'cambridge-counseling',
      addressLine1: '872 Massachusetts Ave Suite 2-2',
      addressLine2: 'Cambridge, MA 02139',
    },
    {
      link: 'waltham-counseling',
      addressLine1: '318 Bear Hill Rd Suite 4',
      addressLine2: 'Waltham, MA 02451',
    },
    {
      link: 'newton-counseling',
      addressLine1: '345 Boylston St Suite 201',
      addressLine2: 'Newton, MA 02459',
    },
    {
      link: 'cambridge-therapy',
      addressLine1: '929 Massachusetts Ave Suite M03',
      addressLine2: 'Cambridge, MA 02139',
    },
    {
      link: 'brookline-counseling',
      addressLine1: '1269 Beacon St 2nd Floor',
      addressLine2: 'Brookline, MA 02446',
    },
    {
      link: 'attleboro-counseling',
      addressLine1: '8 N Main St Suite 201',
      addressLine2: 'Attleboro, MA 02703',
    },
    {
      link: 'lexington-counseling',
      addressLine1: '1666 Massachusetts Ave Suite 10, 2nd Floor',
      addressLine2: 'Lexington, MA 02420',
    },
    {
      link: 'worcester-counseling',
      addressLine1: '405 Grove St Suite 201',
      addressLine2: 'Worcester, MA 01605',
    },
    {
      link: 'watertown-counseling',
      addressLine1: '85 Main St Suite 3R',
      addressLine2: 'Watertown, MA 02472',
    },
    {
      link: 'boston-financial-district-counseling',
      addressLine1: '112 Water St Suite 203',
      addressLine2: 'Boston, MA 02109',
    },
    {
      link: 'boston-south-end-counseling',
      addressLine1: '434 Massachusetts Ave Suite 501',
      addressLine2: 'Boston, MA 02118',
    },
    {
      link: 'salem-counseling',
      addressLine1: '70 Washington St Suite 404',
      addressLine2: 'Salem, MA 01970',
    },
    {
      link: 'east-cambridge-counseling',
      addressLine1: '189 Cambridge Street 4th Floor',
      addressLine2: 'Cambridge, MA 02141',
    },
    {
      link: 'somerville-therapy',
      addressLine1: '249 Elm St Suite 13',
      addressLine2: 'Somerville, MA 02144',
    },
    {
      link: 'franklin-counseling',
      addressLine1: '31 Hayward St Suite G2',
      addressLine2: 'Franklin, MA 02038',
    },
    {
      link: 'amherst-counseling',
      addressLine1: '17 Kellogg Avenue Suite 1C',
      addressLine2: 'Amherst, MA 01002',
    },
    {
      link: 'west-springfield-therapy',
      addressLine1: '425 Union Street',
      addressLine2: 'West Springfield, MA 01089',
    },
  ],
  Maryland: [
    {
      link: 'bethesda-counseling',
      addressLine1: '4401 East-West Hwy Suite 504',
      addressLine2: 'Bethesda, MD 20814',
    },
    {
      link: 'columbia-md-counseling-therapy',
      addressLine1: '5410 Lynx Lane Suite 285',
      addressLine2: 'Columbia, MD 21044',
    },
    {
      link: 'silver-spring-md-counseling',
      addressLine1: '1370 Lamberton Dr Suite 13',
      addressLine2: 'Silver Spring, MD 20902',
    },
    {
      link: 'germantown-counseling',
      addressLine1: '19805 Executive Park Cir',
      addressLine2: 'Germantown, MD 20874',
    },
    {
      link: 'baltimore-counseling',
      addressLine1: '2 Hamill Rd Suite 410',
      addressLine2: 'Baltimore, MD 21210',
    },
    {
      link: 'frederick-counseling',
      addressLine1: '5301 Buckeystown Pike Suite 320',
      addressLine2: 'Frederick, MD 21704',
    },
    {
      link: 'towson-counseling',
      addressLine1: '22 West Rd Suite 102',
      addressLine2: 'Towson, MD 21204',
    },
    {
      link: 'nottingham-counseling',
      addressLine1: '8817 Belair Rd Suite 204',
      addressLine2: 'Nottingham, MD 21236',
    },
    {
      link: 'annapolis-counseling-coaching',
      addressLine1: '2553 Housley Rd Suite 104',
      addressLine2: 'Annapolis, MD 21401',
    },
    {
      link: 'owings-mills-counseling',
      addressLine1: '400 Redland Ct Suite 107',
      addressLine2: 'Owings Mills, MD 21117',
    },
    {
      link: 'baltimore-midtown-counseling',
      addressLine1: '1120 North Charles St Suite 101',
      addressLine2: 'Baltimore, MD 21201',
    },
    {
      link: 'baltimore-boston-st-counseling',
      addressLine1: '2700 Lighthouse Pt E Suite 220',
      addressLine2: 'Baltimore, MD 21224',
    },
    {
      link: 'glen-burnie-counseling',
      addressLine1: '801 Cromwell Park Dr Suite 111',
      addressLine2: 'Glen Burnie, MD 21061',
    },
  ],
  Maine: [
    {
      link: 'portland-counseling',
      addressLine1: '550 Forest Ave Suite 201',
      addressLine2: 'Portland, ME 04101',
    },
  ],
  Michigan: [
    {
      link: 'west-bloomfield-counseling',
      addressLine1: '7439 Middlebelt Rd Suite 3',
      addressLine2: 'West Bloomfield, MI 48322',
    },
    {
      link: 'sterling-heights-counseling',
      addressLine1: '7333 Triangle Drive 1st Floor',
      addressLine2: 'Sterling Heights, MI 48314',
    },
    {
      link: 'beverly-hills-therapy',
      addressLine1: '31000 Lahser Rd Suite 5',
      addressLine2: 'Beverly Hills, MI 48025',
    },
    {
      link: 'royal-oak-counseling',
      addressLine1: '302 South Main St Suite 202',
      addressLine2: 'Royal Oak, MI 48067',
    },
    {
      link: 'troy-counseling',
      addressLine1: '1555 W Big Beaver Rd 2nd Floor',
      addressLine2: 'Troy, MI 48084',
    },
    {
      link: 'detroit-counseling',
      addressLine1: '615 Griswold St Suite 707',
      addressLine2: 'Detroit, MI 48226',
    },
    {
      link: 'grand-rapids-counseling',
      addressLine1: '710 Kenmoor Ave SE Suite 100',
      addressLine2: 'Grand Rapids Charter Township, MI 49546',
    },
    {
      link: 'portage-counseling',
      addressLine1: '524 E Milham Ave Suite B',
      addressLine2: 'Portage, MI 49002',
    },
    {
      link: 'novi-counseling',
      addressLine1: '39500 W 10 Mile Rd Suite 108',
      addressLine2: 'Novi, MI 48375',
    },
  ],
  Minnesota: [
    {
      link: 'rochester-counseling',
      addressLine1: '1706 Greenview Place SW 2nd Floor',
      addressLine2: 'Rochester, MN 55902',
    },
    {
      link: 'minneapolis-counseling',
      addressLine1: '1624 Harmon Place Suite 300',
      addressLine2: 'Minneapolis, MN 55403',
    },
    {
      link: 'eden-prairie-counseling',
      addressLine1: '300 Prairie Center Dr Suite 110',
      addressLine2: 'Eden Prairie, MN 55344',
    },
  ],
  Missouri: [
    {
      link: 'kansas-city-counseling',
      addressLine1: '4010 Washington Street Suite 201',
      addressLine2: 'Kansas City, MO 64111',
    },
    {
      link: 'st-louis-counseling',
      addressLine1: '10 S Euclid Ave Suite C',
      addressLine2: 'St. Louis, MO 63108',
    },
    {
      link: 'st-louis-therapy',
      addressLine1: '6780 Southwest Ave Suite 2A',
      addressLine2: 'St Louis, MO 63143',
    },
    {
      link: 'springfield-counseling',
      addressLine1: '3322 S Campbell Ave Suite T-2',
      addressLine2: 'Springfield, MO 65807',
    },
    {
      link: 'arnold-counseling',
      addressLine1: '3685 West Outer Rd Suite 2C',
      addressLine2: 'Arnold, MO 63010',
    },
    {
      link: 'st-charles-counseling',
      addressLine1: '1360 S 5th St Suite 101',
      addressLine2: 'St Charles, MO 63301',
    },
  ],
  Mississippi: [
    {
      link: 'jackson-counseling',
      addressLine1: '4811 Old Canton Rd Suite A',
      addressLine2: 'Jackson, MS 39211',
    },
    {
      link: 'hattiesburg-counseling',
      addressLine1: '423 Weathersby Rd Suite 150',
      addressLine2: 'Hattiesburg, MS 39402',
    },
    {
      link: 'biloxi-counseling',
      addressLine1: "1641 Popp's Ferry Rd Suite A2",
      addressLine2: 'Biloxi, MS 39532',
    },
    {
      link: 'flowood-counseling',
      addressLine1: '629 Lakeland East Dr Suite G',
      addressLine2: 'Flowood, MS 39232',
    },
  ],
  Montana: [
    {
      link: 'billings-counseling',
      addressLine1: '404 N 31st St Suite 415',
      addressLine2: 'Billings, MT 59101',
    },
  ],
  'North Carolina': [
    {
      link: 'raleigh-counseling',
      addressLine1: '8406 Six Forks Road Suite 104',
      addressLine2: 'Raleigh, NC 27615',
    },
    {
      link: 'durham-counseling',
      addressLine1: '5826 Fayetteville Rd Suite 211',
      addressLine2: 'Durham, NC 27713',
    },
    {
      link: 'winston-salem-counseling',
      addressLine1: '2150 Country Club Rd Suite 228',
      addressLine2: 'Winston-Salem, NC 27104',
    },
    {
      link: 'greensboro-counseling',
      addressLine1: '3300 Battleground Ave Suite 220',
      addressLine2: 'Greensboro, NC 27410',
    },
    {
      link: 'cary-counseling',
      addressLine1: '119 SW Maynard Rd Suite 200',
      addressLine2: 'Cary, NC 27511',
    },
    {
      link: 'chapel-hill-counseling',
      addressLine1: '1516 E Franklin St Suite 200',
      addressLine2: 'Chapel Hill, NC 27517',
    },
    {
      link: 'northeast-raleigh-counseling',
      addressLine1: '3000 Highwoods Blvd Suite 100',
      addressLine2: 'Raleigh, NC 27604',
    },
    {
      link: 'fayetteville-counseling',
      addressLine1: '111 Lamon St Suite 133',
      addressLine2: 'Fayetteville, NC 28301',
    },
    {
      link: 'asheville-counseling',
      addressLine1: '82 Patton Ave Suite 217',
      addressLine2: 'Asheville, NC 28801',
    },
    {
      link: 'charlotte-counseling',
      addressLine1: '4412 Park Rd Suite B',
      addressLine2: 'Charlotte, NC 28209',
    },
    {
      link: 'charlotte-therapy',
      addressLine1: '3111 Springbank Lane Suite I',
      addressLine2: 'Charlotte, NC 28226',
    },
    {
      link: 'wilmington-therapy',
      addressLine1: '3333 Wrightsville Ave Suite G112',
      addressLine2: 'Wilmington, NC 28403',
    },
    {
      link: 'cornelius-counseling',
      addressLine1: '19901 W Catawba Ave Suite 102',
      addressLine2: 'Cornelius, NC 28031',
    },
    {
      link: 'durham-therapy',
      addressLine1: '505 S Duke Street Suite 302',
      addressLine2: 'Durham, NC 27701',
    },
    {
      link: 'raleigh-therapy',
      addressLine1: '16 West Martin Street Suite 201',
      addressLine2: 'Raleigh, NC 27601',
    },
  ],
  'North Dakota': [
    {
      link: 'fargo-counseling',
      addressLine1: '3245 42nd St S Suite 100',
      addressLine2: 'Fargo, ND 58104',
    },
  ],
  Nebraska: [
    {
      link: 'lincoln-counseling',
      addressLine1: '300 N 44th St Suite 103',
      addressLine2: 'Lincoln, NE 68503',
    },
  ],
  'New Hampshire': [
    {
      link: 'bedford-counseling',
      addressLine1: '173 S River Rd Suite 2',
      addressLine2: 'Bedford, NH 03110',
    },
    {
      link: 'nashua-counseling',
      addressLine1: '71 Spit Brook Rd #205',
      addressLine2: 'Nashua, NH 03060',
    },
  ],
  'New Jersey': [
    {
      link: 'edison-therapy',
      addressLine1: '7 Lincoln Hwy Suite 224',
      addressLine2: 'Edison, NJ 08820',
    },
    {
      link: 'dumont-counseling',
      addressLine1: '175 Washington Ave Suite F',
      addressLine2: 'Dumont, NJ 07628',
    },
    {
      link: 'jersey-city-counseling',
      addressLine1: '35 Journal Square Plaza Suite 915',
      addressLine2: 'Jersey City, NJ 07306',
    },
    {
      link: 'newark-counseling',
      addressLine1: '290 Chestnut St Suite 217',
      addressLine2: 'Newark, NJ 07105',
    },
    {
      link: 'paramus-counseling',
      addressLine1: '11-13 Sunflower Avenue Suite 1020',
      addressLine2: 'Paramus, NJ 07652',
    },
    {
      link: 'cherry-hill-counseling',
      addressLine1: '1030 Kings Hwy N Suite 202',
      addressLine2: 'Cherry Hill, NJ 08034',
    },
    {
      link: 'toms-river-counseling',
      addressLine1: '10 Allen Street Suite 4-B',
      addressLine2: 'Toms River, NJ 08753',
    },
    {
      link: 'red-bank-counseling',
      addressLine1: '65 Mechanic St Suite 203',
      addressLine2: 'Red Bank, NJ 07701',
    },
  ],
  'New Mexico': [
    {
      link: 'albuquerque-counseling',
      addressLine1: '6200 Seagull Street Northeast Suite C',
      addressLine2: 'Albuquerque, NM 87109',
    },
    {
      link: 'rio-rancho-counseling',
      addressLine1: '2600 The American Rd SE Suite 215',
      addressLine2: 'Rio Rancho, NM 87124',
    },
  ],
  Nevada: [
    {
      link: 'henderson-counseling',
      addressLine1: '1401 North Green Valley Parkway Suite 260',
      addressLine2: 'Henderson, NV 89074',
    },
    {
      link: 'reno-counseling',
      addressLine1: '9855 Double R Blvd Suite 105',
      addressLine2: 'Reno, NV 89521',
    },
  ],
  'New York': [
    {
      link: 'williamsville-counseling',
      addressLine1: '1120 Youngs Rd Suite 300',
      addressLine2: 'Williamsville, NY 14221',
    },
  ],
  Ohio: [
    {
      link: 'cincinnati-counseling',
      addressLine1: '2300 Montana Ave',
      addressLine2: 'Cincinnati, OH 45211',
    },
    {
      link: 'cleveland-counseling',
      addressLine1: '2800 Euclid Ave Suite 100',
      addressLine2: 'Cleveland, OH 44115',
    },
    {
      link: 'toledo-counseling',
      addressLine1: '425 Jefferson Ave',
      addressLine2: 'Toledo, OH 43604',
    },
    {
      link: 'columbus-counseling',
      addressLine1: '1890 Northwest Blvd Suite 140',
      addressLine2: 'Columbus, OH 43212',
    },
    {
      link: 'beachwood-therapy',
      addressLine1: '23811 Chagrin Boulevard Suite 315',
      addressLine2: 'Beachwood, OH 44122',
    },
    {
      link: 'cincinnati-therapy',
      addressLine1: '2752 Erie Ave Suite 5',
      addressLine2: 'Cincinnati, OH 45208',
    },
    {
      link: 'riverside-therapy',
      addressLine1: '4130 Linden Ave Suite 170',
      addressLine2: 'Riverside, OH 45432',
    },
    {
      link: 'lakewood-counseling',
      addressLine1: '14650 Detroit Avenue Suite 110',
      addressLine2: 'Lakewood, OH 44107',
    },
    {
      link: 'columbus-therapy',
      addressLine1: '1120 Polaris Parkway #204',
      addressLine2: 'Columbus, OH 43240',
    },
    {
      link: 'cleveland-south-counseling',
      addressLine1: '17951 Jefferson Park Road',
      addressLine2: 'Middleburg Heights, OH 44130',
    },
  ],
  Oklahoma: [
    {
      link: 'norman-counseling',
      addressLine1: '2776 Washington Dr Suite 100',
      addressLine2: 'Norman, OK 73069',
    },
    {
      link: 'oklahoma-city-counseling',
      addressLine1: '3000 United Founders Blvd Suite 142',
      addressLine2: 'Oklahoma City, OK 73112',
    },
  ],
  Oregon: [
    {
      link: 'bend-counseling',
      addressLine1: '300 SE Reed Market RD Suite 140',
      addressLine2: 'Bend, OR 97702',
    },
    {
      link: 'salem-or-counseling',
      addressLine1: '1144 Madison Street Northeast Suite F',
      addressLine2: 'Salem, OR 97301',
    },
    {
      link: 'medford-counseling',
      addressLine1: '216 East Main St Suite 201',
      addressLine2: 'Medford, OR 97501',
    },
    {
      link: 'tigard-counseling',
      addressLine1: '9735 SW Shady Ln Suite 304',
      addressLine2: 'Tigard, OR 97223',
    },
  ],
  Pennsylvania: [
    {
      link: 'philadelphia-counseling',
      addressLine1: '1518 Walnut Street Suite 202, Suite 208',
      addressLine2: 'Philadelphia, PA 19102',
    },
    {
      link: 'bensalem-counseling',
      addressLine1: '1950 Street Rd Suite 410',
      addressLine2: 'Bensalem, PA 19020',
    },
    {
      link: 'philadelphia-therapy',
      addressLine1: '1800 John F Kennedy Boulevard Suite 1404',
      addressLine2: 'Philadelphia, PA 19103',
    },
    {
      link: 'bethlehem-counseling',
      addressLine1: '2223 Linden St Suite 101',
      addressLine2: 'Bethlehem, PA 18017',
    },
    {
      link: 'philadelphia-center-city-counseling',
      addressLine1: '1015 Chestnut St Suite 403, Suite 1520',
      addressLine2: 'Philadelphia, PA 19107',
    },
    {
      link: 'pittsburgh-counseling',
      addressLine1: '5830 Ellsworth Ave Suite 301',
      addressLine2: 'Pittsburgh, PA 15232',
    },
    {
      link: 'philadelphia-counseling-south-40th-street',
      addressLine1: '22 S 40th St Suite 201B',
      addressLine2: 'Philadelphia, PA 19104',
    },
    {
      link: 'pittsburgh-fourth-ave-counseling',
      addressLine1: '307 Fourth Ave Suite 901',
      addressLine2: 'Pittsburgh, PA 15222',
    },
    {
      link: 'allentown-counseling',
      addressLine1: '1320 Hausman Rd Suite 100',
      addressLine2: 'Allentown, PA 18104',
    },
    {
      link: 'wyomissing-counseling',
      addressLine1: '4 Park Plaza Suite 105B',
      addressLine2: 'Wyomissing, PA 19610',
    },
    {
      link: 'media-counseling',
      addressLine1: '600 N Jackson St Suite 300',
      addressLine2: 'Media, PA 19063',
    },
  ],
  'Rhode Island': [
    {
      link: 'providence-counseling',
      addressLine1: '827 N Main St Suite 3',
      addressLine2: 'Providence, RI 02904',
    },
  ],
  'South Carolina': [
    {
      link: 'north-charleston-counseling',
      addressLine1: '4975 Lacross Rd Suite 351',
      addressLine2: 'North Charleston, SC 29406',
    },
    {
      link: 'charleston-counseling',
      addressLine1: '215 E Bay St Suite 404',
      addressLine2: 'Charleston, SC 29401',
    },
    {
      link: 'greenville-counseling',
      addressLine1: '68 Pointe Cir Suite 3201, Suite 3102',
      addressLine2: 'Greenville, SC 29615',
    },
    {
      link: 'columbia-therapy',
      addressLine1: '113 Executive Pointe Blvd Suite 104',
      addressLine2: 'Columbia, SC 29210',
    },
    {
      link: 'mt-pleasant-counseling',
      addressLine1: '1131 Queensborough Blvd Suite 100',
      addressLine2: 'Mt Pleasant, SC 29464',
    },
    {
      link: 'rock-hill-counseling',
      addressLine1: '1030 Riverwalk Parkway Suite 203',
      addressLine2: 'Rock Hill, SC 29730',
    },
    {
      link: 'columbia-counseling',
      addressLine1: '1501 Main Street Suite 140',
      addressLine2: 'Columbia, SC 29201',
    },
  ],
  'South Dakota': [
    {
      link: 'sioux-falls-counseling',
      addressLine1: '3900 W Technology Cir Suite 7',
      addressLine2: 'Sioux Falls, SD 57106',
    },
  ],
  Tennessee: [
    {
      link: 'memphis-counseling',
      addressLine1: '1750 Madison Ave Suite 410',
      addressLine2: 'Memphis, TN 38104',
    },
    {
      link: 'nashville-counseling',
      addressLine1: '4004 Hillsboro Rd Suite 207-A',
      addressLine2: 'Nashville, TN 37215',
    },
    {
      link: 'chattanooga-counseling',
      addressLine1: '1307 East Main Street Suite 121',
      addressLine2: 'Chattanooga, TN 37404',
    },
    {
      link: 'johnson-city-counseling',
      addressLine1: '174 W Springbrook Dr',
      addressLine2: 'Johnson City, TN 37604',
    },
    {
      link: 'knoxville-counseling',
      addressLine1: '320 N Peters Rd Suite C',
      addressLine2: 'Knoxville, TN 37922',
    },
  ],
  Texas: [
    {
      link: 'dallas-counseling',
      addressLine1: '2821 McKinney Ave Suite 9',
      addressLine2: 'Dallas, TX 75204',
    },
    {
      link: 'houston-counseling',
      addressLine1: '3201 Allen Pkwy Suite E250',
      addressLine2: 'Houston, TX 77019',
    },
    {
      link: 'fort-worth-counseling',
      addressLine1: '1412 W Magnolia Ave Suite 210',
      addressLine2: 'Fort Worth, TX 76104',
    },
    {
      link: 'el-paso-counseling',
      addressLine1: '1155 Westmoreland Dr Suite 103',
      addressLine2: 'El Paso, TX 79925',
    },
    {
      link: 'katy-counseling',
      addressLine1: '23410 Grand Reserve Dr Suite 301',
      addressLine2: 'Katy, TX 77494',
    },
    {
      link: 'irving-counseling',
      addressLine1: '825 West Royal Lane Suite 220',
      addressLine2: 'Irving, TX 75039',
    },
    {
      link: 'missouri-city-counseling',
      addressLine1: '5819 Hwy 6 Suite 255',
      addressLine2: 'Missouri City, TX 77459',
    },
    {
      link: 'san-antonio-counseling',
      addressLine1: '7979 Broadway Suite 100',
      addressLine2: 'San Antonio, TX 78209',
    },
    {
      link: 'arlington-tx-counseling',
      addressLine1: '5817 West Interstate 20 Suite 490',
      addressLine2: 'Arlington, TX 76017',
    },
    {
      link: 'amarillo-counseling',
      addressLine1: '7120 West Interstate Highway 40 Suite 422',
      addressLine2: 'Amarillo, TX 79106',
    },
    {
      link: 'midland-counseling',
      addressLine1: '4400 N Midland Dr Suite 2910',
      addressLine2: 'Midland, TX 79707',
    },
    {
      link: 'helotes-counseling',
      addressLine1: '12030 Bandera Rd Suite 110-A',
      addressLine2: 'Helotes, TX 78023',
    },
    {
      link: 'houston-therapy',
      addressLine1: '11811 East Fwy Suite 630-10',
      addressLine2: 'Houston, TX 77029',
    },
    {
      link: 'grand-prairie-counseling',
      addressLine1: '1000 Post & Paddock Road Suite 102',
      addressLine2: 'Grand Prairie, TX 75050',
    },
    {
      link: 'carrollton-counseling',
      addressLine1: '2765 E Trinity Mills Road Suite 400',
      addressLine2: 'Carrollton, TX 75006',
    },
    {
      link: 'pflugerville-counseling',
      addressLine1: '2911 South A.W. Grimes Boulevard Suite 330',
      addressLine2: 'Pflugerville, TX 78660',
    },
    {
      link: 'north-austin-counseling',
      addressLine1: '9300 Research Blvd Suite 320',
      addressLine2: 'Austin, TX 78759',
    },
    {
      link: 'bastrop-counseling',
      addressLine1: '1106 College St Suite E3, Suite E5',
      addressLine2: 'Bastrop, TX 78602',
    },
    {
      link: 'cedar-park-counseling',
      addressLine1: '345 Cypress Creek Rd Suite 102',
      addressLine2: 'Cedar Park, TX 78613',
    },
    {
      link: 'austin-counseling',
      addressLine1: '10816 Crown Colony Dr Suite 100',
      addressLine2: 'Austin, TX 78747',
    },
    {
      link: 'the-woodlands-counseling',
      addressLine1: '1201 Lake Woodlands Dr Suite 4009',
      addressLine2: 'The Woodlands, TX 77380',
    },
    {
      link: 'pearland-counseling',
      addressLine1: '2743 Smith Ranch Rd Suite 801',
      addressLine2: 'Pearland, TX 77584',
    },
    {
      link: 'houston-willowbrook-counseling',
      addressLine1: '16310 Tomball Pkwy Suite 104',
      addressLine2: 'Houston, TX 77064',
    },
    {
      link: 'beaumont-counseling',
      addressLine1: '2305 North St Suite 210',
      addressLine2: 'Beaumont, TX 77702',
    },
    {
      link: 'college-station-counseling',
      addressLine1: '111 University Drive Suite 150',
      addressLine2: 'College Station, TX 77840',
    },
    {
      link: 'odessa-counseling',
      addressLine1: '4001 Penbrook St Suite 316',
      addressLine2: 'Odessa, TX 79762',
    },
    {
      link: 'lubbock-counseling',
      addressLine1: '4903 82nd St Suite 60',
      addressLine2: 'Lubbock, TX 79424',
    },
    {
      link: 'conroe-counseling',
      addressLine1: '3210 North Frazier Street Suite C',
      addressLine2: 'Conroe, TX 77303',
    },
    {
      link: 'corpus-christi-counseling',
      addressLine1: '5350 South Staples Street Suite 333D',
      addressLine2: 'Corpus Christi, TX 78411',
    },
    {
      link: 'league-city-counseling',
      addressLine1: '3023 Marina Bay Dr Suite 204',
      addressLine2: 'League City, TX 77573',
    },
    {
      link: 'rowlett-counseling',
      addressLine1: '3705 Lakeview Pkwy Suite 301',
      addressLine2: 'Rowlett, TX 75088',
    },
    {
      link: 'cypress-counseling',
      addressLine1: '15103 Mason Rd Suite E2',
      addressLine2: 'Cypress, TX 77433',
    },
    {
      link: 'pasadena-counseling',
      addressLine1: '7219 Fairmont Pkwy Suite 135',
      addressLine2: 'Pasadena, TX 77505',
    },
    {
      link: 'kingwood-counseling',
      addressLine1: '611 Rockmead Drive Suite 100',
      addressLine2: 'Kingwood, TX 77339',
    },
    {
      link: 'waco-counseling',
      addressLine1: '1000 W Hwy 6 #150',
      addressLine2: 'Waco, TX 76712',
    },
    {
      link: 'san-antonio-therapy',
      addressLine1: '21727 Interstate 10 Suite 106',
      addressLine2: 'San Antonio, TX 78257',
    },
    {
      link: 'little-elm-counseling',
      addressLine1: '2601 Little Elm Parkway #103',
      addressLine2: 'Little Elm, TX 75068',
    },
    {
      link: 'mckinney-counseling',
      addressLine1: '3721 S Stonebridge Dr Unit 1402',
      addressLine2: 'McKinney, TX 75070',
    },
    {
      link: 'spring-counseling',
      addressLine1: '20008 Champion Forest Dr Ste 704',
      addressLine2: 'Spring, TX 77379',
    },
    {
      link: 'austin-counseling-therapy',
      addressLine1: '7004 Bee Cave Road Suite 222',
      addressLine2: 'Austin, TX 78746',
    },
    {
      link: 'georgetown-counseling',
      addressLine1: '1911 North Austin Ave Suite 302',
      addressLine2: 'Georgetown, TX 78626',
    },
    {
      link: 'round-rock-counseling',
      addressLine1: '2200 North A W Grimes Boulevard Suite 510',
      addressLine2: 'Round Rock, TX 78665',
    },
  ],
  Utah: [
    {
      link: 'salt-lake-city-counseling',
      addressLine1: '515 South 700 East Suite 3-E',
      addressLine2: 'Salt Lake City, UT 84102',
    },
    {
      link: 'ogden-counseling',
      addressLine1: '3544 Lincoln Avenue Suite 14E',
      addressLine2: 'Ogden, UT 84401',
    },
    {
      link: 'orem-counseling',
      addressLine1: '1160 S State St Suite 270',
      addressLine2: 'Orem, UT 84097',
    },
  ],
  Virginia: [
    {
      link: 'richmond-counseling',
      addressLine1: '1901 E Franklin St Suite 108',
      addressLine2: 'Richmond, VA 23223',
    },
    {
      link: 'virginia-beach-therapy',
      addressLine1: '509 Old Great Neck Road Suite 203',
      addressLine2: 'Virginia Beach, VA 23454',
    },
    {
      link: 'alexandria-therapy',
      addressLine1: '3014 Colvin St Suite 1-A',
      addressLine2: 'Alexandria, VA 22314',
    },
    {
      link: 'richmond-therapy',
      addressLine1: '5310 Markel Rd Suite 102',
      addressLine2: 'Richmond, VA 23230',
    },
    {
      link: 'midlothian-counseling',
      addressLine1: '13817 Village Mill Dr 2nd Floor',
      addressLine2: 'Midlothian, VA 23114',
    },
    {
      link: 'newport-news-counseling',
      addressLine1: '1030 Loftis Blvd Suite 102',
      addressLine2: 'Newport News, VA 23606',
    },
    {
      link: 'chesapeake-counseling',
      addressLine1: '3804 Poplar Hill Rd Suite D',
      addressLine2: 'Chesapeake, VA 23321',
    },
    {
      link: 'manassas-counseling',
      addressLine1: '10755 Ambassador Dr Suite 201',
      addressLine2: 'Manassas, VA 20109',
    },
    {
      link: 'alexandria-counseling',
      addressLine1: '6076 Franconia Rd Suite D',
      addressLine2: 'Alexandria, VA 22310',
    },
    {
      link: 'virginia-beach-counseling',
      addressLine1: '516 S Independence Blvd Suite 104',
      addressLine2: 'Virginia Beach, VA 23452',
    },
    {
      link: 'mclean-counseling',
      addressLine1: '1311-A Dolley Madison Blvd Suite 3D-2',
      addressLine2: 'McLean, VA 22101',
    },
    {
      link: 'reston-counseling',
      addressLine1: '11260 Roger Bacon Dr Suite 103, Suite 206',
      addressLine2: 'Reston, VA 20190',
    },
    {
      link: 'lynchburg-counseling',
      addressLine1: '1000 Jefferson St Suite 1B',
      addressLine2: 'Lynchburg, VA 24504',
    },
    {
      link: 'arlington-counseling',
      addressLine1: '5303 Lee Hwy',
      addressLine2: 'Arlington, VA 22207',
    },
    {
      link: 'woodbridge-counseling',
      addressLine1: '2501 Hunter Pl Suite 202',
      addressLine2: 'Woodbridge, VA 22192',
    },
    {
      link: 'norfolk-counseling',
      addressLine1: '901 Hampton Blvd Suite 301',
      addressLine2: 'Norfolk, VA 23507',
    },
    {
      link: 'richmond-west-broad-counseling',
      addressLine1: '1657 West Broad St Suite 200',
      addressLine2: 'Richmond, VA 23220',
    },
    {
      link: 'mclean-elm-st-counseling',
      addressLine1: '6861 Elm St Suite 3A',
      addressLine2: 'McLean, VA 22101',
    },
    {
      link: 'harrisonburg-counseling',
      addressLine1: '370 Neff Ave',
      addressLine2: 'Harrisonburg, VA 22801',
    },
    {
      link: 'williamsburg-counseling',
      addressLine1: '5372 Discovery Park Blvd Suite 204',
      addressLine2: 'Williamsburg, VA 23188',
    },
    {
      link: 'charlottesville-counseling',
      addressLine1: '400 Locust Ave Suite 4',
      addressLine2: 'Charlottesville, VA 22902',
    },
    {
      link: 'blacksburg-counseling',
      addressLine1: '106 Southpark Dr Suite C',
      addressLine2: 'Blacksburg, VA 24060',
    },
    {
      link: 'henrico-therapy',
      addressLine1: '12093-95 Gayton Rd',
      addressLine2: 'Henrico, VA 23238',
    },
    {
      link: 'chesterfield-counseling',
      addressLine1: '9846 Lori Road Suite 210',
      addressLine2: 'Chesterfield, VA 23832',
    },
    {
      link: 'charlottesville-therapy',
      addressLine1: '2300 Commonwealth Dr Suite 100',
      addressLine2: 'Charlottesville, VA 22901',
    },
    {
      link: 'roanoke-therapy',
      addressLine1: '3235 Electric Road Suite 1A',
      addressLine2: 'Roanoke, VA 24018',
    },
    {
      link: 'fredericksburg-counseling',
      addressLine1: '701 Kenmore Ave Suite 105',
      addressLine2: 'Fredericksburg, VA 22401',
    },
    {
      link: 'ashland-counseling',
      addressLine1: '201 North Washington Highway Suite 201',
      addressLine2: 'Ashland, VA 23005',
    },
    {
      link: 'abingdon-counseling',
      addressLine1: '361 Falls Dr',
      addressLine2: 'Abingdon, VA 24210',
    },
  ],
  Washington: [
    {
      link: 'seattle-counseling',
      addressLine1: '10303 Meridian Ave N Suite 200',
      addressLine2: 'Seattle, WA 98133',
    },
    {
      link: 'bellingham-counseling',
      addressLine1: '114 W Magnolia St Suite 303',
      addressLine2: 'Bellingham, WA 98225',
    },
    {
      link: 'vancouver-counseling',
      addressLine1: '4610 NE 77th Ave Suite 139',
      addressLine2: 'Vancouver, WA 98662',
    },
  ],
  Wisconsin: [
    {
      link: 'appleton-counseling',
      addressLine1: '330 West College Avenue Suite 303',
      addressLine2: 'Appleton, WI 54911',
    },
    {
      link: 'kenosha-counseling',
      addressLine1: '2105 22nd Ave Suite 7',
      addressLine2: 'Kenosha, WI 53140',
    },
    {
      link: 'waukesha-counseling',
      addressLine1: '2727 North Grandview Blvd Suite 124',
      addressLine2: 'Waukesha, WI 53188',
    },
    {
      link: 'greenfield-counseling',
      addressLine1: '4848 South 76th Street St #201',
      addressLine2: 'Greenfield, WI 53220',
    },
  ],
  'West Virginia': [
    {
      link: 'morgantown-counseling',
      addressLine1: '1230 Suncrest Towne Centre Drive',
      addressLine2: 'Morgantown, WV 26505',
    },
  ],
  Wyoming: [
    {
      link: 'cheyenne-counseling',
      addressLine1: '2232 Dell Range Blvd Suite 312',
      addressLine2: 'Cheyenne, WY 82009',
    },
  ],
}

const validateUsaState = (state: string): boolean =>
  Object.keys(stateAbbreviations).includes(state.toUpperCase())

export default validateUsaState
